import React from 'react';
import Header from './Header';
import Notices from './Notices';
import RecommendedDonors from './RecommendedDonors';
import Keywords from './Keywords';
import NoteArticles from './NoteArticles';
import ForumBanner from './ForumBanner';
import Usage from './Usage';
import Reason from './Reason';
import Voice from './Voice';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';

const Top = () => {
  useTitle('Ton Bébé | 精子提供マッチングサービス');

  return (
    <div>
      <Header />
      <main className="top">
        <Notices />
        <RecommendedDonors />
        <Keywords />
        <NoteArticles />
        <ForumBanner />
        <Usage />
        <Reason />
        <Voice />
      </main>
      <Footer />
    </div>
  );
}

export default Top;
